import { render, staticRenderFns } from "./BundleProductsLayer.vue?vue&type=template&id=016f762c&scoped=true&"
import script from "./BundleProductsLayer.vue?vue&type=script&lang=ts&"
export * from "./BundleProductsLayer.vue?vue&type=script&lang=ts&"
import style0 from "./BundleProductsLayer.vue?vue&type=style&index=0&id=016f762c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016f762c",
  null
  
)

export default component.exports